module.exports = __webpack_public_path__ + "img/caselist25.fb5d4b53.jpg";